export const isValidOptionalHourlyWage = (value: string | undefined | null): boolean => {
  const trimmed = (value ?? '').trim()
  if (!trimmed) return true
  if (!/^\d+(?:[.,]\d+)?$/.test(trimmed)) return false
  return Number(trimmed.replace(',', '.')) >= 0
}

export const normalizeOptionalHourlyWage = (
  value: string | undefined | null,
): number | null => {
  const trimmed = (value ?? '').trim()
  if (!trimmed) return null
  return Number(trimmed.replace(',', '.'))
}

export type ParentEmployeurInfoPayload = {
  parent_title?: string
  parent_first_name?: string
  parent_last_name?: string
  parent_email?: string
  parent_mobile_phone?: string
  parent_pajemploi_number?: string
  hourly_wage: number | null
}

export const buildParentEmployeurInfoPayload = (data: {
  parent_title?: string
  parent_first_name?: string
  parent_last_name?: string
  parent_email?: string
  parent_mobile_phone?: string
  parent_pajemploi_number?: string
  hourly_wage?: string
}): ParentEmployeurInfoPayload => ({
  parent_title: data.parent_title,
  parent_first_name: data.parent_first_name,
  parent_last_name: data.parent_last_name,
  parent_email: data.parent_email,
  parent_mobile_phone: data.parent_mobile_phone,
  parent_pajemploi_number: data.parent_pajemploi_number,
  hourly_wage: normalizeOptionalHourlyWage(data.hourly_wage),
})
